import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, useTheme, Box, Container, Typography, Grid } from '@material-ui/core';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import { BUTTON_TYPES } from '../../common/constant.js';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import PropTypes__default from 'prop-types';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { retrieveContentfulImage } from '../../common/image.js';

var useStyles = makeStyles(function (theme) {
  return {
    title: _defineProperty({
      marginBottom: theme.spacing(8)
    }, theme.breakpoints.down("xs"), {
      marginBottom: theme.spacing(3)
    }),
    subtitle: {
      display: "block",
      marginBottom: theme.spacing(2)
    },
    img: {
      width: theme.spacing(12.5),
      height: theme.spacing(12.5),
      marginBottom: theme.spacing(3)
    },
    container: {
      maxWidth: theme.spacing(124)
    },
    description: {
      "& h5": {
        marginBottom: theme.spacing(2)
      },
      "& > p": {
        marginBottom: theme.spacing(4)
      },
      "& ul": {
        margin: theme.spacing(0),
        textAlign: "left",
        listStyle: "none",
        padding: theme.spacing(0)
      },
      "& li": {
        display: "flex",
        alignItems: "center",
        "&::before": {
          content: "'✓'",
          marginRight: theme.spacing(3)
        }
      },
      "& li:not(:last-child)": {
        marginBottom: theme.spacing(2)
      }
    }
  };
});
var ComparisonCards = function ComparisonCards(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    bgColor = _ref.bgColor,
    gridColumns = _ref.gridColumns,
    gridSpacing = _ref.gridSpacing,
    items = _ref.items,
    onButtonClick = _ref.onButtonClick;
  var classes = useStyles();
  var theme = useTheme();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    textAlign: "center",
    py: 10
  }, /*#__PURE__*/React__default.createElement(Container, {
    className: classes.container
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "overline",
    className: classes.subtitle
  }, subtitle), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h1",
    component: "h2",
    className: classes.title
  }, title), /*#__PURE__*/React__default.createElement(Grid, {
    spacing: isExtraSmallScreen() ? 3 : gridSpacing,
    container: true,
    justifycontent: "center"
  }, items && items.map(function (i) {
    var _BUTTON_TYPES$i$cta$t, _i$cta, _BUTTON_TYPES$i$cta$t2, _i$cta2, _i$cta3, _i$cta5;
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      container: true,
      key: i === null || i === void 0 ? void 0 : i.id,
      xs: 12,
      sm: 6,
      md: gridColumns ? 12 / gridColumns : 12
    }, /*#__PURE__*/React__default.createElement(Box, {
      borderRadius: 32,
      width: "100%",
      bgcolor: i === null || i === void 0 ? void 0 : i.bgColor,
      display: "flex",
      flexDirection: "column"
    }, /*#__PURE__*/React__default.createElement(Box, {
      py: 3
    }, (i === null || i === void 0 ? void 0 : i.imageUrl) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      src: retrieveContentfulImage(i.imageUrl, {
        width: 100,
        height: 100
      }),
      className: classes.img,
      alt: (i === null || i === void 0 ? void 0 : i.imageTitle) || ""
    }), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h4",
      component: "h3"
    }, i === null || i === void 0 ? void 0 : i.title)), (i === null || i === void 0 ? void 0 : i.description) && /*#__PURE__*/React__default.createElement(Box, {
      py: 3,
      px: 2,
      height: "100%",
      bgcolor: theme.palette.text.white,
      borderLeft: "".concat(theme.spacing(0.25), "px solid ").concat(i === null || i === void 0 ? void 0 : i.bgColor),
      borderRight: "".concat(theme.spacing(0.25), "px solid ").concat(i === null || i === void 0 ? void 0 : i.bgColor),
      className: classes.description
    }, /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
      markdownString: i.description
    })), (i === null || i === void 0 ? void 0 : i.cta) && /*#__PURE__*/React__default.createElement(Box, {
      mt: "auto",
      py: 2
    }, /*#__PURE__*/React__default.createElement(CustomButton, {
      variant: (_BUTTON_TYPES$i$cta$t = BUTTON_TYPES[(_i$cta = i.cta) === null || _i$cta === void 0 ? void 0 : _i$cta.type]) === null || _BUTTON_TYPES$i$cta$t === void 0 ? void 0 : _BUTTON_TYPES$i$cta$t.variant,
      color: (_BUTTON_TYPES$i$cta$t2 = BUTTON_TYPES[(_i$cta2 = i.cta) === null || _i$cta2 === void 0 ? void 0 : _i$cta2.type]) === null || _BUTTON_TYPES$i$cta$t2 === void 0 ? void 0 : _BUTTON_TYPES$i$cta$t2.color,
      href: (_i$cta3 = i.cta) === null || _i$cta3 === void 0 ? void 0 : _i$cta3.url,
      onClick: function onClick() {
        var _i$cta4;
        return onButtonClick((_i$cta4 = i.cta) === null || _i$cta4 === void 0 ? void 0 : _i$cta4.id);
      },
      size: "large"
    }, (_i$cta5 = i.cta) === null || _i$cta5 === void 0 ? void 0 : _i$cta5.label))));
  }))));
};
ComparisonCards.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  gridColumns: PropTypes__default.oneOf([1, 2, 3, 4, 6, 12]),
  gridSpacing: PropTypes__default.number,
  items: PropTypes__default.arrayOf(PropTypes__default.shape({
    id: PropTypes__default.string,
    bgColor: PropTypes__default.string,
    imageUrl: PropTypes__default.string,
    title: PropTypes__default.string,
    description: PropTypes__default.string,
    cta: PropTypes__default.shape({
      id: PropTypes__default.string,
      type: PropTypes__default.oneOf(["Outlined", "Primary", "Text", "Secondary"]),
      label: PropTypes__default.string,
      url: PropTypes__default.string
    })
  })),
  onButtonClick: PropTypes__default.func
};

export { ComparisonCards as default };
//# sourceMappingURL=ComparisonCards.js.map
